export default "__VITE_ASSET__BUSJESaY__"